import React from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Table
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToggleOff, faToggleOn, faPencil, faTrash } from "@fortawesome/free-solid-svg-icons";

import Paginator from "../Paginator";
import "./style.scss";

const JamlyfTable = (props) => {
  const {
    data,
    dataKeysHasHeader = false,
    showActions,
    editIcon = faPencil,
    deleteIcon = faTrash,
    onEditActionClick,
    onDeleteActionClick,
    headers = [],
    headerMapper,
    handleBoolUpdate,
    onPageChange,
    totalPages } = props;

  const tableData = data?.map((item) => {
    const orderedObj = {};
    orderedObj["id"] = item.id;
    Object.keys(headerMapper).forEach((key) => {
      orderedObj[headerMapper[key]] = item[key];
    });
    return orderedObj;
  });

  const getTableHeader = () => {
    return tableData && tableData.length && dataKeysHasHeader
      ? Object.keys(tableData[0]).filter((colName) => colName !== 'id')
      : headers;
  };

  const getStatusBadgeBg = (status) => {
    const statusMap = {
      Success: 'success',
      Failure: 'danger',
      Pending: 'warning',
    };
    return statusMap[status] || 'secondary';
  };

  return (
    <Col>
      <Card className="shadow">
        <Table responsive>
          <thead className="thead-light">
            <tr>
              {getTableHeader().map((colName) => (
                <th scope="col" key={colName}>
                  {colName}
                </th>
              ))}
              {showActions && <th scope="col">Actions</th>}
            </tr>
          </thead>
          <tbody>
            {tableData &&
              tableData.map((item, idx) => {
                const { id, ...itemWithoutId } = item;
                return (
                  <tr key={idx}>
                    {Object.entries(itemWithoutId).map(([key, value], index) => (
                      <td key={index}>
                        {key === 'description' ? (
                          <div className="align-items-center">
                            <span className="mb-0 text-sm tableTitle">{value}</span>
                          </div>
                        ) : key === 'status' ? (
                          <Badge bg={getStatusBadgeBg(value)}>{value}</Badge>
                        ) : typeof value === 'boolean' ? (
                          <Button
                            size="lg"
                            variant="outline"
                            onClick={handleBoolUpdate(item)}
                          >
                            <FontAwesomeIcon
                              icon={item.available ? faToggleOn : faToggleOff}
                              className="toggle-menu"
                            />
                          </Button>
                        ) : (
                          value
                        )}
                      </td>
                    ))}
                    <td>
                      {onEditActionClick && (
                        <Button
                          size="lg"
                          variant="link"
                          onClick={() => onEditActionClick(item)}
                          className="edit-action-btn"
                        >
                          <FontAwesomeIcon icon={editIcon} className="editBtn" />
                        </Button>
                      )}
                      {onDeleteActionClick && (
                        <Button
                          size="lg"
                          variant="link"
                          onClick={() => onDeleteActionClick(item)}
                          className="del-action-btn"
                        >
                          <FontAwesomeIcon icon={deleteIcon} className="delBtn" />
                        </Button>
                      )}
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>
        <Card.Footer className="py-4">
          {data.length ? (
            <Paginator totalPages={totalPages} onPageChange={onPageChange} />
          ) : (
            <p className="text-center text-muted">No data to show</p>
          )}
        </Card.Footer>
      </Card>
    </Col>
  );
}

export default JamlyfTable;
